import Util from "../../Util";
import React, { useState, useEffect, useCallback } from "react";
import {
  Space,
  message,
  Table,
  Button,
  Typography,
  Select,
  Modal,
  Input,
} from "antd";
const { Text, Link, Title } = Typography;
const { TextArea } = Input;

const moment = require("moment-timezone");

const TIMEZONE = "Asia/Bangkok";

function StaffReport() {
  const [messageApi, contextHolder] = message.useMessage();
  const [storeOptions, setStoreOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [needActionReports, setNeedActionReports] = useState([]);
  const [recentHasActionReports, setRecentHasActionReports] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalRow, setModalRow] = useState({});
  const [selectedStore, setSelectedStore] = useState(-2);
  const [storeMap, setStoreMap] = useState(new Map());
  const [actionMessage, setActionMessage] = useState("");
  const [modalLoading, setModalLoading] = useState(false);

  const columns = [
    {
      title: "วัน/เวลา",
      dataIndex: "created",
      key: "created",
    },
    {
      title: "มหาวิทยาลัย",
      dataIndex: "store",
      key: "store",
      render: (val, _) => {
        return <Text>{storeMap.get(val)}</Text>;
      },
    },
    {
      title: "Link sheet",
      dataIndex: "sheet",
      key: "sheet",
      render: (text, _) => {
        return (
          <Link
            href={"/staff/sheetedit?" + text}
            target="_blank"
            rel="noopener noreferrer"
          >
            คลิกเพื่อดู
          </Link>
        );
      },
    },
    {
      title: "หมวดหมู่ของ Report",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "ข้อความ",
      dataIndex: "message",
      key: "message",
    },
    {
      title: "Take Action",
      dataIndex: "_",
      key: "_",
      render: (_, row) => {
        return (
          <Button
            onClick={() => {
              openModal(row);
            }}
            type="primary"
          >
            Take action
          </Button>
        );
      },
    },
  ];

  const actionedColumns = [
    ...columns.slice(0, -1),
    {
      title: "Action เดิม",
      dataIndex: "action",
      key: "action",
    },
    columns[columns.length - 1],
  ];

  const loadReport = useCallback(
    async (store) => {
      setSelectedStore(store);
      setLoading(true);
      const data = await Util.sendPost("/api/moresheetStaff/getReport", {
        store,
      });
      if (!data.success) {
        messageApi.error("Error Loading");
        setLoading(false);
        return;
      }

      const formatReport = (row) => {
        return {
          ...row,
          created: moment.tz(row.created, TIMEZONE).toLocaleString(),
        };
      };

      setNeedActionReports(data.data.active.map(formatReport));
      setRecentHasActionReports(data.data.passive.map(formatReport));

      setLoading(false);
    },
    [messageApi]
  );

  useEffect(() => {
    const initialFetch = async () => {
      setLoading(true);
      const data = await Util.sendPost("/api/moresheetStaff/getReportMeta", {});
      if (!data.success) {
        messageApi.error("Error Loading");
        setLoading(false);
        return;
      }
      const storeOptions = data.data.stores.map((store) => {
        return { value: store.code, label: store.name.join(" - ") };
      });
      const storeMap = new Map(
        data.data.stores.map((store) => {
          return [store.code, store.name.join(" - ")];
        })
      );
      setStoreMap(storeMap);
      setStoreOptions(storeOptions);
      setLoading(false);
      loadReport(storeOptions[0].value);
    };
    initialFetch();
  }, [loadReport, messageApi]);

  const openModal = (row) => {
    setModalRow(row);
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const sendAction = async () => {
    setModalLoading(true);
    console.log(modalRow._id);
    const data = await Util.sendPost("/api/moresheetStaff/actionReport", {
      id: modalRow._id,
      action: actionMessage,
    });
    setModalLoading(false);
    if (!data.success) {
      message.error(`Error! ${data.msg[0]}`);
      return;
    }

    setActionMessage("");
    setIsModalVisible(false);
    loadReport(selectedStore);
  };

  return (
    <Space direction="vertical" size={12}>
      {contextHolder}

      <Modal
        title="จัดการ Report"
        open={isModalVisible}
        onOk={sendAction}
        onCancel={closeModal}
        okText="บันทึก Action"
      >
        {modalLoading ? (
          <React.Fragment>
            <Text>Loading...</Text>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Title level={5}>เวลา</Title>
            <Text>{modalRow.created}</Text>
            <Title level={5}>มหาวิทยาลัย</Title>
            <Text>{storeMap.get(modalRow.store)}</Text>
            <Title level={5}>ชีท</Title>
            <Link
              href={"/staff/sheetedit?" + modalRow.sheet}
              target="_blank"
              rel="noopener noreferrer"
            >
              คลิกเพื่อดู
            </Link>
            <Title level={5}>หมวดหมู่ของ Report</Title>
            <Text>{modalRow.category}</Text>
            <Title level={5}>ข้อความ</Title>
            <Text>{modalRow.message}</Text>
            {modalRow.dealt ? (
              <React.Fragment>
                <Title level={5}>Action เดิม</Title>
                <Text>{modalRow.action}</Text>
                <Title level={5}>
                  Action ใหม่ (จะถูกบันทึกไว้รวมทั้งส่งให้ผู้ report):
                </Title>
                <TextArea
                  rows={5}
                  value={actionMessage}
                  onChange={(event) => {
                    setActionMessage(event.currentTarget.value);
                  }}
                ></TextArea>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Title level={5}>
                  Acion ที่ได้ทำไป (จะถูกบันทึกไว้รวมทั้งส่งให้ผู้ report):
                </Title>
                <TextArea
                  rows={5}
                  value={actionMessage}
                  onChange={(event) => {
                    setActionMessage(event.currentTarget.value);
                  }}
                ></TextArea>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </Modal>

      <Title level={2}>Reports</Title>
      <Text>จัดการคำร้องเรียนจากคนซื้อชีท</Text>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <React.Fragment>
          <Title level={4}>เลือกมหาวิทยาลัย</Title>
          <Select
            showSearch
            placeholder="เลือกมหาวิทยาลัย"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={storeOptions}
            style={{ width: "500px" }}
            value={selectedStore}
            onChange={(store) => {
              loadReport(store);
            }}
          />
          <Title level={4}>Report ที่ยังไม่ถูกจัดการ</Title>
          <Table dataSource={needActionReports} columns={columns}></Table>
          <Title level={4}>Report ที่จัดการแล้วในรอบ 30 วันที่ผ่านมา</Title>
          <Table
            dataSource={recentHasActionReports}
            columns={actionedColumns}
          ></Table>
        </React.Fragment>
      )}
    </Space>
  );
}

export default StaffReport;
